var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterRIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_595_1476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25C3.71978 0.25 0.25 3.71978 0.25 8C0.25 12.2802 3.71978 15.75 8 15.75C12.2802 15.75 15.75 12.2802 15.75 8C15.75 3.71978 12.2802 0.25 8 0.25ZM14.75 8C14.75 11.7082 11.7483 14.75 8 14.75C4.29178 14.75 1.25 11.7483 1.25 8C1.25 4.29178 4.25172 1.25 8 1.25C11.7082 1.25 14.75 4.25172 14.75 8ZM11.2308 11.6967C9.46094 8.42291 9.61225 8.69919 9.55331 8.60144C10.4006 8.22959 10.932 7.36919 10.932 6.32566C10.932 4.51522 9.78219 3.81947 7.99709 3.81947H5.77566C5.56887 3.81947 5.40066 3.98769 5.40066 4.19447V11.875C5.40066 12.0818 5.56887 12.25 5.77566 12.25H6.30403C6.51081 12.25 6.67903 12.0818 6.67903 11.875V8.91081H8.27625L9.96387 12.0524C9.9959 12.1122 10.0435 12.1621 10.1017 12.1969C10.1599 12.2317 10.2264 12.25 10.2942 12.25H10.9009C11.1853 12.25 11.3659 11.9463 11.2308 11.6967ZM8.313 7.71141H6.67906V5.01888H8.03097C8.67834 5.01888 9.63106 5.053 9.63106 6.34822C9.63103 7.20178 9.13831 7.71141 8.313 7.71141Z",
    fill: "#6B6662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_595_1476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterRIcon);
export default __webpack_public_path__ + "static/media/letter-r-icon.f9b14d4fd7009b2cca465212d3d33a68.svg";
export { ForwardRef as ReactComponent };